import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import RouteGuard from "./utils/RouteGoard";
import Login from "./pages/Login";
import Unauthorized from "./pages/Unauthorized";
import NotFound from "./pages/NotFound";
import { publicRoutes, roleBasedRoutes } from "./routes";
import QzTrayInitComponent from "./component/qz-tray/QzTrayInitComponent";
import QzTrayPrintCommandReceiverSocket from "./component/qz-tray/QzTrayPrintCommandReceiverSocket";
import LoginSessionDataUpdate from "./component/profile/LoginSessionDataUpdated";
import OrderEventReceiverSocket from "./component/restaurants/orders/OrderEventReceiverSocket";
import FcmInitComponentV2 from "./component/common/FcmInitComponentV2";
import SocketAsPushNotification from "./component/SocketAsPushNotification";
import SocketTableLayout from "./component/sockets/SocketTableLayout";

export default function App() {
  return (
    <Router>
      <QzTrayInitComponent />
      <QzTrayPrintCommandReceiverSocket />
      <LoginSessionDataUpdate />
      <OrderEventReceiverSocket />
      <SocketTableLayout />
      <SocketAsPushNotification />
      <FcmInitComponentV2 />
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Public Routes */}
        {publicRoutes.map((route, index) => (
          <Route key={`public-${index}`} path={route.path} element={route.element} />
        ))}

        <Route path="/unauthorized" element={<Unauthorized />} />

        {roleBasedRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<RouteGuard allowedRoles={route.roles}>{route.element}</RouteGuard>}
          />
        ))}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
